<template>
  <div class="module-container">
    <div class="module-header">
      <div class="module-title" style="font-weight: bolder;">
        <span>医废管理</span>
      </div>
      <span class="more-link" @click="goToMedicalWasteDetail">查看更多</span>
    </div>
    <div class="module-content">
      <div v-for="(item, index) in wasteData" :key="index" class="waste-item">
        <div class="item-name">{{ item.name }}</div>
        <div class="item-stats">
          <div class="stat-group">
            <span class="stat-label">产生量</span>
            <span class="stat-value" :title="formatWeight(item.production).tooltip">{{ formatWeight(item.production).display }}</span>
          </div>
          <div class="stat-group">
            <span class="stat-label">袋数</span>
            <span class="stat-value" :title="item.bags + '袋'">{{ item.bags }}袋</span>
          </div>
          <div class="stat-group">
            <span class="stat-label">运出量</span>
            <span class="stat-value" :title="formatWeight(item.shipOut).tooltip">{{ formatWeight(item.shipOut).display }}</span>
          </div>
          <div class="stat-group">
            <span class="stat-label">袋数</span>
            <span class="stat-value" :title="item.shipOutBags + '袋'">{{ item.shipOutBags }}袋</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { medicalWasteStatistics } from '@/api/medicalMatchManSystem/medicalWasteMan/wasteBusinessMan'
import { addDate, getCurTimeYMD } from '@/utils/index'

export default {
  name: 'MedicalWasteManagement',
  data() {
    return {
      wasteData: [],
      loading: false,
      refreshInterval: null
    }
  },
  mounted() {
    this.fetchWasteData()
    // 设置定时刷新，每30分钟刷新一次
    this.refreshInterval = setInterval(this.fetchWasteData, 1800000)
  },
  beforeDestroy() {
    // 清除定时器，避免内存泄漏
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  methods: {
    formatWeight(weight) {
      // 将重量格式化，超过1000kg转换为吨
      if (weight >= 1000) {
        const tons = (weight / 1000).toFixed(2)
        return {
          display: `${tons}吨`,
          tooltip: `${weight}kg (${tons}吨)`
        }
      } else {
        return {
          display: `${weight}kg`,
          tooltip: `${weight}kg`
        }
      }
    },
    async fetchWasteData() {
      this.loading = true
      // 先清空数据，确保即使数据不变也能触发重新渲染
      this.wasteData = []
      try {
        const projectId = JSON.parse(window.localStorage.userInfo).projectId;
        const endDate = getCurTimeYMD();
        const startDate = addDate(endDate, -7);
        const { data } = await medicalWasteStatistics({
          projectId: projectId,
          startDate: startDate,
          endDate: endDate
        })
        if (data.code === "200") {
          const overall = data.data.overall
          const categories = data.data.categories || []

          this.wasteData = [
            {
              name: '总体',
              production: overall.totalProduceWeight || 0,
              bags: overall.totalProduceCount || 0,
              shipOut: overall.totalShipOutWeight || 0,
              shipOutBags: overall.totalShipOutCount || 0
            },
            ...categories.map(category => ({
              name: category.typeName || '未知类型',
              production: category.produceWeight || 0,
              bags: category.produceCount || 0,
              shipOut: category.shipOutWeight || 0,
              shipOutBags: category.shipOutCount || 0
            }))
          ]
        }else{
          this.$message({
            type: 'error',
            message: data.msg
          })
        }
      }  finally {
        this.loading = false
      }
    },
    goToMedicalWasteDetail() {
      // 获取用户权限
      const userRoles = JSON.parse(decodeURI(window.localStorage.userRoles))
      // 计算日期参数（最近7天）
      const endDate = getCurTimeYMD()
      const startDate = addDate(endDate, -7)

      // 检查是否有医废明细查询权限
      const hasDetailPermission = userRoles && (userRoles.includes('yifeimingxizonghechaxunwuqianzi') || userRoles.includes('yifeimingxizonghechaxunwuqianziydy'));
      if (hasDetailPermission) {
        // 有权限，跳转到医废明细查询
        this.$router.push({
          path: '/medicalWasteMan/comprehensiveDetailQueryNoSign',
          query: {
            startDate,
            endDate
          }
        });
      } else {
        // 无权限，提示
        this.$message({
          type: 'warning',
          message: '您暂无权限访问医废明细查询'
        });
      }

    }
  }
}</script>

<style scoped lang="scss">
.module-container {
  height: 330px;
  display: flex;
  flex-direction: column;
}

.module-header {
  display: flex;
  align-items: center;
}

.module-title {
  width: 435px;
  height: 30px;
  color: #fff;
  text-align: center;
  background: url("/static/image/equip/shebeiyunxingzhuangtai-bg.png") no-repeat center;

  span {
    margin-left: -187px;
    font-family: Source Han Sans CN;
    font-weight: 800;
    font-size: 19px;
    color: #FFFFFF;
  }
}

.more-link {
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s;
}

.more-link:hover {
  text-decoration: underline;
}

.module-content {
  margin: 12px 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  scrollbar-width: none;
}

.module-content::-webkit-scrollbar {
  width: 0 !important;
}

.waste-item {
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
  cursor: pointer;
  background-image: url('/static/image/six/background-blue.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  padding: 10px 0px 10px 80px;
}

.waste-item:first-child {
  background-image: url('/static/image/six/background-yellow.png');
}

.item-name {
  font-size: 16px;
  color: #fff;
  font-weight: 600;
  width: 95px;
  margin-right: 10px;
}

.item-stats {
  display: flex;
  gap: 5px;
  flex: 1;
  align-items: center;
}

.stat-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 25%;
}

.stat-label {
  font-size: 11px;
  color: #fff;
  margin-bottom: 4px;
  width: 100%;
}

.stat-value {
  font-size: 16px;
  color: #fff;
  font-weight: 600;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
